<ion-app *transloco="let t">
  <ion-menu side="start" contentId="content">
    <ion-content>
      <ion-grid class="ion-no-padding">
        <div class="safearea-wrapper">
          <ion-row class="ion-no-padding banner">
            <ion-col size="4" style="min-height: 90px">
              <div style="margin-top: 10px;">
              <ion-img style="width: 80px; height: auto;" src="assets/images/LOGO.png"></ion-img>
              </div>
            </ion-col>
          </ion-row>
        </div>
        <ion-item-divider></ion-item-divider>
        <ion-menu-toggle>
          <ion-list lines="none">
            <ion-item
            (click)="reloadIfSame('/catalogs')"
              routerLink="/catalogs"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <ion-icon name="home"></ion-icon>
              {{t('common.menu.catalogs')}}
            </ion-item>
            <ion-item (click)="reloadIfSame('/establishments')" routerLink="/establishments" routerLinkActive="active" >
              <ion-icon name="home"></ion-icon>
              {{t('common.menu.catalogsImported')}}
            </ion-item>
            <ion-item routerLink="/newsletters" routerLinkActive="active">
              <ion-icon name="notifications"></ion-icon>
              {{t('common.menu.newsletters')}}
            </ion-item>
            <ion-item routerLink="/promotions" routerLinkActive="active">
              <ion-icon name="pricetag"></ion-icon>
              {{t('common.menu.promotions')}}
            </ion-item>
            <ion-item *ngIf="showLoyaltyCards" routerLink="/loyalty-cards" routerLinkActive="active">
              <ion-icon name="card"></ion-icon>
              {{t('common.menu.loyaltyCards')}}
            </ion-item>
          </ion-list>
          <ion-item-divider></ion-item-divider>
          <ion-list lines="none">
            <ion-item routerLink="/config" routerLinkActive="active">
              <ion-icon name="settings"></ion-icon>
              {{t('common.menu.configuration')}}
            </ion-item>
            <ion-item routerLink="/profile" routerLinkActive="active">
              <ion-icon name="person"></ion-icon>
              {{t('common.menu.profile')}}
            </ion-item>
            <ion-button ion-item fill="clear" (click)="handleShare()">
              <ion-icon name="people"></ion-icon>
              {{t('common.menu.share')}}
            </ion-button>
          </ion-list>
          <ion-item-divider></ion-item-divider>
          <ion-list lines="none">
            <ion-item routerLink="/auth" class="danger" (click)="toggleMenu()">
              <ion-icon [name]="userLoggedIn ? 'power' : 'log-in'"></ion-icon>
              {{ t(userLoggedIn ? 'common.menu.logout': 'common.menu.login') }}
            </ion-item>
          </ion-list>
          <ion-list lines="none">
            <div style="display: flex !important; justify-content: center !important;">
                 <ion-img src="assets/images/Next.jpg" style="width: 200px; height: auto;"></ion-img>
            </div>
          </ion-list>
          <ion-list lines="none">
              <div style="display: flex !important; justify-content: center !important;">
                <ion-img src="assets/images/Recuperacion.png" style="width: 200px; height: auto;"></ion-img>
              </div>
          </ion-list>
          <ion-list lines="none" >
            <ion-img src="assets/images/Gobierno.png"></ion-img>
          </ion-list>
        </ion-menu-toggle>
      </ion-grid>
    </ion-content>
    
  <ion-footer class="bar-stable">
 <!-- Selector e información -->
  
  <div class="selector-container">
    <div class="selector-wrapper">
      <div class="dropdown-selector" (click)="toggleDropdown()">
        <img *ngIf="selectedOption" [src]="selectedOption.img" class="avatar" />
        <span class="label">{{ selectedOption?.text || t('map.selector') }}</span>
        <ion-icon name="chevron-down-outline"></ion-icon>
      </div>
      <div class="version">
        <small>{{ versionNumber }}</small>
      </div>
    </div>
    <!-- Lista desplegable -->
    <div class="dropdown-list" *ngIf="dropdownOpen" >
      <div class="dropdown-option" *ngFor="let option of options" (click)="selectOption(option)">
        <img [src]="option.img" class="avatar" />
        <span class="label"> {{ option.text }}</span>
      </div>
    </div>
  </div>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="content"></ion-router-outlet>
</ion-app>
